import { render, staticRenderFns } from "./PartitionValuation.vue?vue&type=template&id=58ff20cf&scoped=true"
import script from "./PartitionValuation.vue?vue&type=script&lang=js"
export * from "./PartitionValuation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ff20cf",
  null
  
)

export default component.exports